export const LOADING_NOTIFICACION = 'LOADING_NOTIFICACION';
export const FACTURAS_TOTALES = 'FACTURAS_TOTALES';
export const OBTENER_LISTADO_EMISION_FACTURAS =
    'OBTENER_LISTADO_EMISION_FACTURAS';
export const SELECCIONAR_PAGINA_FACTURA = 'SELECCIONAR_PAGINA_FACTURA';

export const RECIBOS_OBTENER_LISTA = 'RECIBOS_OBTENER_LISTA';
export const RECIBOS_LISTA_LOADING = 'RECIBOS_LISTA_LOADING';
export const RECIBOS_MODAL_LOADING = 'RECIBOS_MODAL_LOADING';
